import React from 'react'
import PurpleBtn from '../components/btns/PurpleBtn'
import { useNavigate } from 'react-router-dom';
import RejectedImg from '../assets/img/rejected.png'

const RejectedPage = () => {
    const navigate = useNavigate();

    const backHome = () => {
        navigate('/')
    }
  return (
    <div className='flex justify-center items-center w-full h-screen'>
        <div className='max-w-[350px]'>
            <img src={RejectedImg} alt="" className='max-w-[350px]'/>
            <p className='text-white font-semibold text-center'>Əməliyyat uğursuz tamamlandı</p>
            <div className='flex justify-center mt-4'>
                <PurpleBtn onClick={backHome} title={'Qayıt'}/>
            </div>
        </div>

    </div>
  )
}

export default RejectedPage